/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export const Tracking = ({ locale }: { locale?: string }): React.JSX.Element | null => {
	const trackingEnabled = Boolean(
		(!process.env.NEXT_PUBLIC_TRACKING_DISABLED || process.env.NEXT_PUBLIC_TRACKING_DISABLED === "false") &&
		process.env.NEXT_PUBLIC_TRACKING_BASE,
	);

	if (trackingEnabled) {
		const url = new URL(`${process.env.NEXT_PUBLIC_TRACKING_BASE}/tracking.js`);

		if (process.env.NEXT_PUBLIC_DSA_TRACKING_ID) {
			url.searchParams.set("p", process.env.NEXT_PUBLIC_DSA_TRACKING_ID);
		}

		if (locale) {
			url.searchParams.set("l", locale);
		}

		if (process.env.NEXT_PUBLIC_TRACKING_VERSION && process.env.NEXT_PUBLIC_TRACKING_SCRIPT_HASH) {
			url.searchParams.set("version", process.env.NEXT_PUBLIC_TRACKING_VERSION);
			return (
				<script
					key="tracking-script"
					crossOrigin="anonymous"
					integrity={process.env.NEXT_PUBLIC_TRACKING_SCRIPT_HASH}
					src={url.toString()}
					async
				/>
			);
		}

		return <script key="tracking-script" src={url.toString()} async />;
	}

	return null;
};
